// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import StudentProfileLayout from './StudentProfileLayout';

import EleveService from '../../services/EleveService';

const DeleteStudent = () => {
	const [student, setStudent] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([EleveService.getEleve(id)]).then(([eleveData]) => {
			setStudent(eleveData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the EleveService to delete the student
			await EleveService.deleteEleve(id);

			// Redirect the user to the list of students
			navigate('/education/eleves');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression des informations de l'élève",
				error
			);
		}
	};

	return (
		<StudentProfileLayout>
			{student && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{student.nom || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement le profil de cet élève.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez le profil de cet élève, il sera désinscrit
									de tous ses cours et toutes les données le concernant seront
									définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer le profil de l'élève
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</StudentProfileLayout>
	);
};

export default DeleteStudent;
